import { Tag, Button, Tooltip } from "antd";
import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";

const GtTag = styled(Tag)`
  border-radius: 1rem;
  margin-right: auto;
`;

const ColoredBulletLink = ({
  text,
  unassign = () => {},
  allowClear = false,
  cleared = false,
  tagColor = '#EADCFD',
  textColor = '#4F2D7F',
  tooltipText = 'Unassign',
}) => {
  let returnedJSX = null;

  switch (text) {
    case "Not Assigned":
      returnedJSX = (
        <GtTag color="#E6DBF7">
          <span style={{ color: "#344054" }}>{text}</span>
        </GtTag>
      );
      break;

    case "-":
      returnedJSX = (
        <GtTag color="#E6DBF7" style={{ visibility: "hidden" }}>
          <span style={{ color: "#344054" }}>{text}</span>
        </GtTag>
      );
      break;

    default:
      returnedJSX = (
        <>
          {cleared ? (
            <GtTag color="#E6DBF7" style={{ visibility: "hidden" }}>
              <span style={{ color: "#344054" }}>{text}</span>
            </GtTag>
          ) : (
            <GtTag color={tagColor}>
              <span style={{ color: textColor }}>{text ?? "-"}</span>
              {allowClear && (
                <Tooltip
                  title={tooltipText}
                  arrow={false}
                  overlayClassName="info-tooltip"
                  mouseEnterDelay={0.5}
                  placement="topRight"
                >
                  <Button
                    type="text"
                    shape="circle"
                    size="small"
                    onClick={unassign}
                    icon={<CloseOutlined style={{ fontSize: "0.5rem", color: textColor}} />}
                  />
                </Tooltip>
              )}
            </GtTag>
          )}
        </>
      );
  }
  return returnedJSX;
};

export default ColoredBulletLink;
